import React from 'react';
import { Formik, Form } from 'formik';
import SubmittingButton from '../../components/buttons/SubmittingButton';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import Checkbox from '@mui/material/Checkbox';
export const ValidationSchema = Yup.object().shape({
  username: Yup.string().required('Field is required'),
  password: Yup.string().required('Field is required'),
});
import { AuthModel } from '../core/_models';
import { useAuth } from '../core/Auth';
import FormikTextField from '../../components/formik/FormikTextField';
import Box from '@mui/material/Box';
import { login } from '../core/_request';

export const LoginForm = () => {


  const { saveAuth, setCurrentUser } = useAuth();

  const handleSubmit = async (values: any) => {
    try {
      const { username, password } = values;

      const isTokenExist = localStorage.getItem('token');

      if (isTokenExist) localStorage.removeItem('token');

      const response = await login({
        username: username,
        password,
      });

      // @ts-ignore
      ///  await mutate({ username, password });
      const dataFromResponse: { user: UserModel; token: string } = response.data;

      var auth: AuthModel = { api_token: dataFromResponse?.token || '' };
      saveAuth(auth);
      //  const user = await getUserByToken(auth.api_token);
      setCurrentUser(dataFromResponse?.user);
    } catch (error) {
      toast.error('Authentication Failed');
    }
  };

  return (
    <React.Fragment>
      <Formik
        initialValues={{
          username: '',
          password: '',
        }}
        validationSchema={ValidationSchema}
        validateOnChange={true}
        onSubmit={handleSubmit}
      >
        {({ isValid, handleSubmit, setFieldTouched, isSubmitting }) => (
          <Form
            onSubmit={(event) => {
              event.preventDefault();
              isValid
                ? handleSubmit(event)
                : Object.keys(ValidationSchema.fields).map((field) => setFieldTouched(field, true));
            }}
            className='h-full w-full z-40'
          >
            <Box
              className=' flex flex-col gap-[30px] px-4 max-w-[330px] items-center justify-center h-full m-auto
            '
              sx={{
                '& .MuiFormLabel-root': {
                  color: '#fff',
                  caretColor: '#fff', // Change cursor/caret color to white
                },
                '& .MuiFormLabel-root.Mui-focused': {
                  color: '#fff',
                },
                '& .MuiInputBase-input': {
                  color: '#fff',
                },

                '& .MuiInputBase-root::before': {
                  borderBottom: '1px solid #fff !important',
                },
                '& .MuiInputBase-root::after': {
                  borderBottom: '1px solid #fff !important',
                },
                '& .MuiInputBase-root:hover::before': {
                  borderBottom: '2px solid #fff !important',
                },
                '& .MuiInputBase-root:hover::after': {
                  borderBottom: '2px solid #fff !important',
                },
                '& .MuiInputBase-root:focus::before': {
                  borderBottom: '2px solid #fff !important',
                },
                '& .MuiInputBase-root:focus::after': {
                  borderBottom: '2px solid #fff !important',
                }, // Add autofill styles here
                '& input:-webkit-autofill': {
                  '-webkit-box-shadow': '0 0 0 30px #083E60 inset !important',
                  '-webkit-text-fill-color': '#fff !important',
                },
                '& input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active':
                {
                  '-webkit-box-shadow': '0 0 0 30px #083E60 inset !important',
                  '-webkit-text-fill-color': '#fff !important',
                },
              }}
            >
              <FormikTextField label='Username' name='username' placeholder='Enter your username' />
              <FormikTextField
                label='Password'
                name='password'
                placeholder='Enter your password'
                type='password'
              />
              <div className=' flex justify-between items-center w-full text-white text-[10px]'>
                <div className='flex items-center justify-between '>
                  <Checkbox
                    className='text-white p-1 '
                    sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                  />
                  <label className='m-0'> remember me </label>
                </div>

                <a className='  underline'>forget password</a>
              </div>
              <SubmittingButton
                loading={isSubmitting}
              >
                  Sign in
          
              </SubmittingButton>
            </Box>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
};
